var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.catalogues),function(catalogue,company,index){return _c('catalogue-section',{key:index,attrs:{"catalogue-sections":catalogue,"catalogue-heading":company,"catalogue-index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }